import { HttpClient, HttpMethods } from "@planzone/services";
import { Document, Folder, Identifiable } from "@planzone/dto";

function copyDocument(httpClient: HttpClient) {
  return (
    document: Identifiable<Document>,
    folder: Identifiable<Folder>,
    type: string,
    namespace: string,
  ) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/document/copy`,
      method: HttpMethods.POST,
      data: {
        sourceFileUuid: document.uuid,
        targetFolderUuid: folder.uuid,
        namespace,
        type,
      },
    });
}

export { copyDocument };
